import SEOLandingTemplate from './SEOLandingTemplate';

export default function DAPAcheckerPage() {
  return (
    <SEOLandingTemplate
      title="DA/PA Checker"
      metaTitle="Free DA/PA Checker - Domain & Page Authority Score | Sungresh"
      metaDescription="Check domain authority and page authority for any website using real DataForSEO ranking data. Bulk check up to 10 domains at once."
      h1="Free DA/PA Checker — Domain & Page Authority"
      sub="Check an authority score for any domain or specific page, sourced from DataForSEO's ranking data. Bulk-check up to 10 domains in one pass."
      keywords="da pa checker, domain authority checker, page authority checker"
      ctaLink="/domain/overview"
      ctaText="Check Authority Free"
      features={[
        { icon: '⭐', title: 'Domain Authority', desc: 'A 0-100 authority estimate for the whole domain' },
        { icon: '📄', title: 'Page-Level Score', desc: 'Authority for a specific URL' },
        { icon: '📦', title: 'Bulk Check', desc: 'Up to 10 domains in one request' },
        { icon: '🔗', title: 'Backlink Counts', desc: 'Total backlinks and referring domains' },
      ]}
      faqs={[
        { q: 'What do "DA" and "PA" actually measure?', a: 'They\'re shorthand for domain-level and page-level authority scores — rough predictors of how likely a site or page is to rank well, based mainly on its backlink profile. Different tools calculate their own versions, so scores aren\'t directly comparable across providers.' },
        { q: 'What counts as a strong authority score?', a: 'It\'s relative to your niche. A newer site is usually in the lower range; established, well-linked sites sit higher. The more useful comparison is against your direct competitors, not an absolute number.' },
        { q: 'How do I raise my authority score over time?', a: 'Earn backlinks from a wider variety of reputable domains rather than many links from one or two sources, and avoid or disavow obviously spammy inbound links. This is a gradual process, typically measured in months, not days.' },
      ]}
    />
  );
}
